"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._DeepMerge = exports._GenerateHash = exports._EarthDistance = exports._GetDataAttributesInModule = exports._ScrollToPageElement = exports._ScrollToTop = exports._CalculateAOV = exports._RoundUpToTwoDecimals = exports._DiffTimes = exports._DataHide = exports._CollapseAndUncollapse = exports._MoveRefObjectButKeepLinkToWrapper = exports._CheckIfExecutedInIframe = exports._MoveRefIdButKeepLinkToWrapper = void 0;
exports._GetElementInModule = _GetElementInModule;
var anime_es_js_1 = __importDefault(require("animejs/lib/anime.es.js"));
var cash_dom_1 = __importDefault(require("cash-dom"));
/**
 * @deprecated
 * Use ref objects instead this mechanism
 * @param refObjectId
 * @param wrapper if not set = using parent
 */
var _MoveRefIdButKeepLinkToWrapper = function (refObjectId, wrapper) {
    if ((0, cash_dom_1.default)(refObjectId).length) {
        (0, exports._MoveRefObjectButKeepLinkToWrapper)((0, cash_dom_1.default)(refObjectId)[0], wrapper);
    }
};
exports._MoveRefIdButKeepLinkToWrapper = _MoveRefIdButKeepLinkToWrapper;
/**
 * If true the current context is inside an iframe
 * @returns
 */
var _CheckIfExecutedInIframe = function () {
    try {
        return window.self !== window.top;
    }
    catch (_a) {
        return true;
    }
};
exports._CheckIfExecutedInIframe = _CheckIfExecutedInIframe;
/**
 * @deprecated
 * use ref-object mechanism instead
 * @param refObject
 * @param wrapper if not set = using parent
 */
var _MoveRefObjectButKeepLinkToWrapper = function (refObject, wrapper) {
    if (!refObject['wrapperLink']) {
        refObject['wrapperLink'] = wrapper || (0, cash_dom_1.default)(refObject).parent();
    }
    (0, cash_dom_1.default)(refObject).appendTo('body'); // ref object to safe place
    refObject.style.cssText += 'display: none !important';
};
exports._MoveRefObjectButKeepLinkToWrapper = _MoveRefObjectButKeepLinkToWrapper;
var _CollapseAndUncollapse = function (container) {
    // Initially set all elements with data-collapse="true" to height 0
    container.find("[data-collapse='true']").css('height', '0');
    container.find("[data-collapse='true']").css('overflow', 'hidden');
    // Click event for elements with data-action="collapse"
    container.find("[data-action='collapse']").on('click', function () {
        // Find sibling elements with data-collapse="true" within the parent
        var collapseElements = (0, cash_dom_1.default)(this).parent().parent().find("[data-collapse='true']");
        if (collapseElements.length === 0) {
            console.warn("No elements with data-collapse='true' found within parent of data-action='collapse'");
        }
        // Toggle the height
        collapseElements.each(function () {
            var el = (0, cash_dom_1.default)(this);
            if (el.height() === 0) {
                // Animate to the required height
                var autoHeight = el.css('height', 'auto').outerHeight();
                (0, anime_es_js_1.default)({
                    targets: el[0], // Pass the raw DOM element
                    height: ["0px", "".concat(autoHeight, "px")],
                    duration: 500,
                    easing: 'easeInOutQuad',
                    complete: function () { return el.css('height', 'auto'); },
                });
            }
            else {
                // Animate back to 0 height
                (0, anime_es_js_1.default)({
                    targets: el[0],
                    height: ["".concat(el.height(), "px"), '0px'],
                    duration: 500,
                    easing: 'easeInOutQuad',
                });
            }
        });
    });
};
exports._CollapseAndUncollapse = _CollapseAndUncollapse;
var _DataHide = function () {
    var hideCallback = function () {
        var el = (0, cash_dom_1.default)(this);
        if ((0, cash_dom_1.default)('#' + el.attr('data-hide'))) {
            (0, cash_dom_1.default)('#' + el.attr('data-hide')).css('display', 'none');
        }
    };
    (0, cash_dom_1.default)('[data-hide]').on('click', hideCallback);
    (0, cash_dom_1.default)('[data-hide]').each(hideCallback);
};
exports._DataHide = _DataHide;
var _DiffTimes = function (from, to) {
    var _a;
    var diffTime = Math.abs(from.valueOf() - to.valueOf());
    var days = diffTime / (24 * 60 * 60 * 1000);
    var hours = (days % 1) * 24;
    var minutes = (hours % 1) * 60;
    var secs = (minutes % 1) * 60;
    _a = [Math.floor(days), Math.floor(hours), Math.floor(minutes), Math.floor(secs)], days = _a[0], hours = _a[1], minutes = _a[2], secs = _a[3];
    console.log(days + 'd', hours + 'h', minutes + 'm', secs + 's');
    return { days: days, hours: hours, minutes: minutes, secs: secs };
};
exports._DiffTimes = _DiffTimes;
var _RoundUpToTwoDecimals = function (num) {
    return Math.ceil(num * 100) / 100;
};
exports._RoundUpToTwoDecimals = _RoundUpToTwoDecimals;
/**
 *
 * @param term
 * @returns
 * @deprecated Use _CalculateAOV_V2
 */
var _CalculateAOV = function (term) {
    var _a, _b, _c;
    var aov = { total: 0, fees: 0, subscription: 0, modules: 0 };
    if ((_a = term === null || term === void 0 ? void 0 : term.priceAdjustmentRules) === null || _a === void 0 ? void 0 : _a.length) {
        term = _ConvertPriceAdjustmentRules(term);
        //number of payments of complete term
        var numberOfPayments_1 = term.termValue / term.paymentFrequencyValue;
        var priceAdjustedValue_1 = 0, numberOfPaymentsWithoutAdjustment_1 = numberOfPayments_1;
        term.convertedPriceAdjustmentRules.forEach(function (a, index) {
            if (a.recurrenceUnit === term.termUnit) {
                //priceadjustments from ML have no "timespan" they only have a "after x month" new price applied
                //so we have to calculate the timespans of each priceadjustment and multiply it with their price
                var upperLimitOfPayments_1 = 0;
                term.convertedPriceAdjustmentRules.slice(index + 1).forEach(function (b) {
                    upperLimitOfPayments_1 += numberOfPayments_1 - +b.recurrenceFrequency;
                });
                a.numberOfPayments = numberOfPayments_1 - a.recurrenceFrequency - upperLimitOfPayments_1;
                priceAdjustedValue_1 += a.numberOfPayments * a.value;
                numberOfPaymentsWithoutAdjustment_1 -= a.numberOfPayments;
            }
        });
        aov.subscription = priceAdjustedValue_1 + numberOfPaymentsWithoutAdjustment_1 * term.price;
    }
    else {
        //calculate value of subscription
        var paymentIntervalMapping = {
            YEAR: 1 / 12,
            MONTH: 1,
            WEEK: 4.34524,
            DAY: 30.4167,
        };
        if (paymentIntervalMapping[term.paymentFrequencyUnit] && paymentIntervalMapping[term.termUnit]) {
            //change contract duration and payment frequency to monthly
            var paymentIntervalPerMonth = (1 / term.paymentFrequencyValue) * paymentIntervalMapping[term.paymentFrequencyUnit];
            var contractDurationInMonth = term.termValue * paymentIntervalMapping[term.termUnit];
            var numberOfPayments = contractDurationInMonth * paymentIntervalPerMonth;
            aov.subscription = numberOfPayments * term.price;
        }
        else {
            console.error('NO mapping interval', term.paymentFrequencyUnit, paymentIntervalMapping);
        }
    }
    //calculate value of fees
    if ((_b = term === null || term === void 0 ? void 0 : term.flatFees) === null || _b === void 0 ? void 0 : _b.length) {
        for (var _i = 0, _d = term.flatFees; _i < _d.length; _i++) {
            var fee = _d[_i];
            if (fee.paymentFrequencyType === 'NON_RECURRING') {
                aov.fees += fee.price;
            }
            else if (fee.paymentFrequencyType === 'RECURRING' &&
                fee.paymentFrequencyValue &&
                term.termUnit === fee.paymentFrequencyUnit) {
                var numberOfRecurringPayments = term.termValue / fee.paymentFrequencyValue;
                aov.fees += fee.price * numberOfRecurringPayments;
            }
        }
    }
    //calculate value for optionalmodules (same code for flatfees (remove))
    if ((_c = term === null || term === void 0 ? void 0 : term.optionalModules) === null || _c === void 0 ? void 0 : _c.length) {
        for (var _e = 0, _f = term.optionalModules; _e < _f.length; _e++) {
            var module_1 = _f[_e];
            if (module_1.paymentFrequencyType === 'NON_RECURRING') {
                aov.modules += module_1.price;
            }
            else if (module_1.paymentFrequencyType === 'RECURRING' &&
                module_1.paymentFrequencyValue &&
                term.termUnit === module_1.paymentFrequencyUnit) {
                var numberOfRecurringPayments = term.termValue / module_1.paymentFrequencyValue;
                aov.modules += module_1.price * numberOfRecurringPayments;
            }
        }
    }
    aov.total = aov.fees + aov.modules + aov.subscription;
    for (var key in aov) {
        aov[key] = (0, exports._RoundUpToTwoDecimals)(aov[key]);
    }
    return aov;
};
exports._CalculateAOV = _CalculateAOV;
/**
 * Magicline pricadjustment objects are trash and have only contextual strings.
 * Therefore we convert it to more machine readable objects.
 * @param term
 * @returns
 */
var _ConvertPriceAdjustmentRules = function (term) {
    var priceAdjustments = term.priceAdjustmentRules.map(function (a) {
        var _a;
        var mapping = {
            woche: 'WEEK',
            monat: 'MONTH',
            jahr: 'YEAR',
            tag: 'DAY',
        };
        var matches = a.recurrenceFrequency.match(/(Nach|Alle) (\d+) (woche|monat|jahr|tag)/i);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) < 3) {
            console.error('Invalid input format', a);
            return undefined;
        }
        if ((matches === null || matches === void 0 ? void 0 : matches.length) > 2) {
            var frequency = matches[1], unit = matches[2];
            var wrongFormat = true;
            for (var key in mapping) {
                if (unit.toLowerCase().includes(key)) {
                    unit = mapping[key];
                    wrongFormat = false;
                }
            }
            var value = 0;
            if ((_a = a.value.match(/\d+[.|,]\d\d/)) === null || _a === void 0 ? void 0 : _a.length) {
                value = +a.value.replace(',', '.').match(/\d+\.\d\d/)[0];
                wrongFormat = false;
            }
            if (wrongFormat === true) {
                return undefined;
            }
            return {
                recurrenceUnit: unit,
                recurrenceFrequency: +frequency,
                value: value,
            };
        }
        else {
            return undefined;
        }
    });
    //hotfix fitnesspoint has adjusted price adjustment rules
    if (priceAdjustments === null || priceAdjustments === void 0 ? void 0 : priceAdjustments.length) {
        priceAdjustments = priceAdjustments.filter(function (a) { return a; });
    }
    term.convertedPriceAdjustmentRules = priceAdjustments;
    return term;
};
var _ScrollToTop = function (offset) {
    if (offset === void 0) { offset = 180; }
    console.log('SCROLLtop');
    window.scrollTo({
        top: document.body.offsetTop - offset,
        behavior: 'smooth',
    });
};
exports._ScrollToTop = _ScrollToTop;
var _ScrollToPageElement = function (element, offset) {
    if (offset === void 0) { offset = 180; }
    if (!element.length)
        return;
    var targetOffset = element.offset().top - offset;
    console.log('SCROLL', targetOffset, element);
    window.scrollTo({ top: targetOffset, behavior: 'smooth' });
};
exports._ScrollToPageElement = _ScrollToPageElement;
function _GetElementInModule(baseElement, selector) {
    // Only add baseElement if it doesn't have the data-module attribute.
    var results = baseElement.find(selector);
    if (!baseElement.is('[data-module]') && baseElement.is(selector)) {
        results = results.add(baseElement);
    }
    return results.filter(function (i, el) {
        var $el = (0, cash_dom_1.default)(el);
        var $module = $el.closest('[data-module]');
        // If there is a module, allow it only if it's the base element or it has data-encapsulation="false"
        return $module.length ? $module[0] === baseElement[0] || $module.attr('data-encapsulation') === 'false' : true;
    });
}
var _GetDataAttributesInModule = function (element, specificSelector) {
    var attributeHandlers = {};
    var valueHandlers = {};
    var $searchScope = _GetElementInModule(element, specificSelector !== null && specificSelector !== void 0 ? specificSelector : '*');
    $searchScope.each(function () {
        var _this = this;
        Array.prototype.forEach.call(this.attributes, function (attr) {
            if (attr.name.startsWith('data-')) {
                // Create AllDataAttributes object
                var dataAttr = {
                    attribute: attr.name,
                    objKey: attr.name.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); }),
                    value: _this.getAttribute(attr.name),
                    element: (0, cash_dom_1.default)(_this),
                };
                // Add to the old mapping
                if (!attributeHandlers[attr.name]) {
                    attributeHandlers[attr.name] = [];
                }
                attributeHandlers[attr.name].push(dataAttr);
                // Add to the new mapping if the attribute has a value
                var val = dataAttr.value;
                if (val) {
                    if (!valueHandlers[val]) {
                        valueHandlers[val] = { attributes: [], elements: [] };
                    }
                    if (!valueHandlers[val].attributes.includes(attr.name)) {
                        valueHandlers[val].attributes.push(attr.name);
                    }
                    if (valueHandlers[val].elements.indexOf((0, cash_dom_1.default)(_this)) === -1) {
                        valueHandlers[val].elements.push((0, cash_dom_1.default)(_this));
                    }
                }
            }
        });
    });
    return { attributeHandlers: attributeHandlers, valueHandlers: valueHandlers };
};
exports._GetDataAttributesInModule = _GetDataAttributesInModule;
var _EarthDistance = function (lat1, lon1, lat2, lon2, unit) {
    if (unit === void 0) { unit = 'K'; }
    if (lat1 == lat2 && lon1 == lon2) {
        return 0;
    }
    else {
        var radlat1 = (Math.PI * lat1) / 180;
        var radlat2 = (Math.PI * lat2) / 180;
        var theta = lon1 - lon2;
        var radtheta = (Math.PI * theta) / 180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = (dist * 180) / Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit == 'K') {
            dist = dist * 1.609344;
        }
        if (unit == 'N') {
            dist = dist * 0.8684;
        }
        return dist;
    }
};
exports._EarthDistance = _EarthDistance;
var _GenerateHash = function (str, seed) {
    if (seed === void 0) { seed = 0; }
    var h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for (var i = 0, ch = void 0; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return String(4294967296 * (2097151 & h2) + (h1 >>> 0));
};
exports._GenerateHash = _GenerateHash;
/**
 * Takes an object (target) and an object (source) and deep overwrites all keys in target from source
 * @param target
 * @param source
 * @returns
 */
var _DeepMerge = function (target, source) {
    for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
        var key = _a[_i];
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
            // If the target key is not an object, initialize it
            if (!target[key] || typeof target[key] !== 'object') {
                target[key] = {};
            }
            // Recursively merge objects
            (0, exports._DeepMerge)(target[key], source[key]);
        }
        else {
            // Otherwise, directly assign values
            target[key] = source[key];
        }
    }
    return target;
};
exports._DeepMerge = _DeepMerge;
